import Toast from 'antd-mobile/lib/toast';
export default Toast;



// WEBPACK FOOTER //
// ./components/toast/index.tsx